import { Col, Container, Row } from "react-grid-system";
import Breadcrumbs from "@components/Breadcrumbs";
import AuthorMetaData from "@components/blog/AuthorMetaData";
import BlogPost from "@components/blog/BlogPost";
import CardLayout from "@components/layout/CardLayout";
import Tags from "@components/Tags";
import { formatPublishDate, stringToURI } from "@scripts/utils";

type BlogTagPageProps = {
  tagName: string;
  posts: BlogPost[];
};

const BlogTagPage = ({ tagName, posts }: BlogTagPageProps) => (
  <Container data-search-exclude>
    <Row>
      <Col>
        <Breadcrumbs
          links={[
            { name: "Blog", url: "/blog" },
            { name: tagName, url: `/blog/tag/${stringToURI(tagName)}` },
          ]}
        />
        <h1>{tagName}</h1>
      </Col>
    </Row>

    <CardLayout
      cards={posts.map((post) => ({
        link: `/blog/${post.slug}`,
        title: post.title,
        description: post.excerpt,
        banner: post.banner,
        date: formatPublishDate(post.publishedAt),
        descriptionExtra: (
          <Tags
            tags={post.tags.map((tag) => ({
              name: tag,
              url: `/blog/tag/${stringToURI(tag)}`,
            }))}
          />
        ),
        footerExtra: <AuthorMetaData author={post.author} />,
      }))}
      limit={6}
    />
  </Container>
);

export default BlogTagPage;
